import { TradingRepo as tradingRepo } from "../trading/trading.repo";
import * as moment from "moment";
import * as _ from "lodash";

class TradingController implements angular.IOnInit {
  public pendingTradeSets: Array<any>;
  public finalisedTradeSets: Array<any>;
  public completedTradeSets: Array<any>;
  public isLoading = false;
  public tradeSheetsCtrl: any;
  // public loadTradeSheets: any={};
  // public loadPortfolioTrades: any={};
  public loadTradeSheets: boolean = false;
  public loadPortfolioTrades: boolean = false;
  public searchFiltersList;
  public fromDate;
  public toDate;
  public currentDate;
  public earliestTradeSetDate;

  /** @ngInject */
  constructor(
    private tradingRepo: tradingRepo,
    private $window: angular.IWindowService
  ) {
    this.loadTradeSheets = false;
  }

  $onInit() {
    this.currentDate = new Date();
    if (_.isEmpty(this.fromDate) || _.isEmpty(this.toDate)) {
      this.fromDate = new Date(
        moment(this.currentDate).subtract(7, "days").toString()
      ); //;
      this.toDate = this.currentDate;
      this.earliestTradeSetDate = moment("2018-01-01").format("YYYY-MM-DD");
    }
  }

  // public selectTradeSheets(){
  //   console.log("select Trade sheets")
  //   this.loadTradeSheets.load();
  // }
  // public selectPortfolioTrades(){
  //   this.loadPortfolioTrades.load();
  // }

  formatDate(selectedDate) {
    return moment(selectedDate).format("YYYY-MM-DD");
  }

  getAllTrades = () => {
    this.fromDate = moment("2018-01-01").format("YYYY-MM-DD");
    this.toDate = moment().format("YYYY-MM-DD");
  };
}

export const trading: angular.IComponentOptions = {
  template: require("./trading.html"),
  controller: TradingController,
};



// WEBPACK FOOTER //
// ./src/app/trading/trading.ts